const PROXY_BASE = '/apps/vantalab-reviews';

function starString(rating) {
  const rounded = Math.round(rating);
  return '★★★★★☆☆☆☆☆'.slice(5 - rounded, 10 - rounded);
}

function escapeHtml(value) {
  return String(value ?? '').replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[c]));
}

async function loadReviews(root) {
  const handle = root.dataset.productHandle;
  const summaryStars = root.querySelector('[data-vlr-summary-stars]');
  const summaryText = root.querySelector('[data-vlr-summary-text]');
  const list = root.querySelector('[data-vlr-review-list]');

  try {
    const res = await fetch(`${PROXY_BASE}/reviews?product=${encodeURIComponent(handle)}`);
    const data = await res.json();

    if (!res.ok) throw new Error(data.error || 'error');

    if (data.count === 0) {
      summaryStars.textContent = '';
      summaryText.textContent = 'Todavía no hay reseñas. ¡Sé el primero!';
      list.innerHTML = '';
      return;
    }

    summaryStars.textContent = starString(data.average);
    summaryText.textContent = `${data.average} de 5 (${data.count} reseña${data.count === 1 ? '' : 's'})`;

    list.innerHTML = data.reviews
      .map(
        (r) => `
        <div class="vantalab-reviews__review-card">
          <div class="vantalab-reviews__stars" aria-hidden="true">${starString(r.rating)}</div>
          ${r.title ? `<strong>${escapeHtml(r.title)}</strong>` : ''}
          <p>${escapeHtml(r.body)}</p>
          ${
            r.photos.length
              ? `<div class="vantalab-reviews__review-photos">${r.photos
                  .map((url) => `<img src="${escapeHtml(url)}" alt="Foto de la reseña" loading="lazy">`)
                  .join('')}</div>`
              : ''
          }
          <span class="vantalab-reviews__empty">${escapeHtml(r.name)}</span>
        </div>`
      )
      .join('');
  } catch (err) {
    summaryText.textContent = 'No se pudieron cargar las reseñas.';
  }
}

async function loadQuestions(root) {
  const handle = root.dataset.productHandle;
  const list = root.querySelector('[data-vlr-question-list]');

  try {
    const res = await fetch(`${PROXY_BASE}/questions?product=${encodeURIComponent(handle)}`);
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'error');

    if (!data.questions.length) {
      list.innerHTML = '<p class="vantalab-reviews__empty">Todavía no hay preguntas sobre este producto.</p>';
      return;
    }

    list.innerHTML = data.questions
      .map(
        (q) => `
        <div class="vantalab-reviews__review-card">
          <strong>${escapeHtml(q.name)} preguntó:</strong>
          <p>${escapeHtml(q.question)}</p>
          ${q.answer ? `<p><strong>Respuesta:</strong> ${escapeHtml(q.answer)}</p>` : '<p class="vantalab-reviews__empty">Sin responder todavía.</p>'}
        </div>`
      )
      .join('');
  } catch (err) {
    list.innerHTML = '<p class="vantalab-reviews__empty">No se pudieron cargar las preguntas.</p>';
  }
}

function setupRatingInput(root) {
  const wrap = root.querySelector('[data-vlr-rating-input]');
  const hidden = root.querySelector('#vlr-rating');
  if (!wrap || !hidden) return;

  wrap.querySelectorAll('button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const value = btn.dataset.rating;
      hidden.value = value;
      wrap.querySelectorAll('button').forEach((b) => {
        const active = Number(b.dataset.rating) <= Number(value);
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', String(active));
      });
    });
  });
}

async function submitForm(root, { form, endpoint, messageEl, extraFields, onSuccess }) {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submitBtn = form.querySelector('[data-vlr-submit]');
    submitBtn.disabled = true;
    messageEl.textContent = '';

    const formData = new FormData(form);
    formData.append('product_handle', root.dataset.productHandle);
    Object.entries(extraFields || {}).forEach(([k, v]) => formData.append(k, v));

    try {
      const res = await fetch(`${PROXY_BASE}/${endpoint}`, { method: 'POST', body: formData });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'No se pudo enviar. Inténtalo de nuevo.');
      messageEl.textContent = data.message || '¡Gracias!';
      form.reset();
      if (onSuccess) onSuccess();
    } catch (err) {
      messageEl.textContent = err.message;
    } finally {
      submitBtn.disabled = false;
    }
  });
}

function init(root) {
  loadReviews(root);
  loadQuestions(root);
  setupRatingInput(root);

  const reviewForm = root.querySelector('[data-vlr-review-form]');
  if (reviewForm) {
    submitForm(root, {
      form: reviewForm,
      endpoint: 'reviews',
      messageEl: root.querySelector('[data-vlr-review-message]'),
      onSuccess: () => loadReviews(root),
    });
  }

  const questionForm = root.querySelector('[data-vlr-question-form]');
  if (questionForm) {
    submitForm(root, {
      form: questionForm,
      endpoint: 'questions',
      messageEl: root.querySelector('[data-vlr-question-message]'),
      onSuccess: () => loadQuestions(root),
    });
  }
}

document.querySelectorAll('[data-vlr-root]').forEach(init);
